/**
 * ページ遷移 シャッターアニメーション
 */
let pageTransition = () => {
  const shutter = document.getElementById('page-transition');
  if (!shutter) return;

  // ページイン：シャッターを上げる
  window.addEventListener('load', () => {
    shutter.classList.add('is-leave');
  });

  // ページアウト：リンククリックでシャッターを下げてから遷移
  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      anchor.target === '_blank' ||
      anchor.hasAttribute('data-bs-toggle') ||
      anchor.hasAttribute('data-bs-dismiss')
    )
      return;

    e.preventDefault();
    shutter.classList.remove('is-leave');

    setTimeout(() => {
      window.location.href = href;
    }, 500);
  });
};

/**
 * 初期化
 */
let init = () => {
  pageTransition();
};

export default { init };
